
import { v4 as uuidv4 } from 'uuid'
import { toast } from 'react-toastify'

import { types } from '../types/types'

import { fetchConToken } from '../../helpers/fetch'
import { initialAddTitles, initialAddItems, initialDuplicateItems, initialCalculoTotales } from '../../helpers/itemsPptoGasto.js'
import { initialCreateBudgetNew, initialCreateBudgetDuplicate, parseToNum } from '../../helpers/pptosGastos'
import { checkValidationStatus } from '../../helpers/pptosProfits'
import { startOpenProgress } from '../actions/general'

export const iniLoadBudgetsDetail = (budgetId) => {
    return async (dispatch) => {
        try {

            dispatch(startOpenProgress(true))

            const resp = await fetchConToken(`buyBudgets/${budgetId}`)
            const body = await resp.json()
            if (body.ok) {
                dispatch(budgetsLoadDetail(body.data))
            }

            dispatch(startOpenProgress(false))

        } catch (error) {
            console.log(error)
            toast.error(error)

            dispatch(startOpenProgress(true))
        }
    }
}

export const iniAddTitle = () => {
    return async (dispatch) => {
        try {
            const newId = uuidv4();
            const newItem = await initialAddTitles(newId);
            dispatch(budgetsAddItem(newItem));
        } catch (error) {
            console.log(error)
        }
    }
}

export const iniAddItem = (idTitle, items, sorting, data = null, categoryId) => {
    return async (dispatch) => {
        try {

            console.log('--sorting--', sorting)

            const newId = uuidv4()

            const newItem = await initialAddItems({
                newId,
                idTitle,
                sorting,
                data: data,
                categoryId
            })

            const newItems = items.map(item => {
                if (item.id === idTitle) {
                    return {
                        ...item,
                        items: [...item.items, newItem]
                    };
                }
                return item;
            });

            dispatch(budgetsLoadItems(newItems));

        } catch (error) {
            console.log(error)
        }
    }
}

export const iniDuplicateItem = (items, item) => {
    return async (dispatch) => {
        try {
            const newId = uuidv4();
            let newItem = initialDuplicateItems(item, newId);

            if (item.tipo === 'title') {
                newItem.items = newItem.items.map(it => {
                    const newIdItem = uuidv4();
                    return {
                        ...it,
                        'id': newIdItem,
                        'index': newIdItem,
                        'id_titulo': newId,
                        'creado': false
                    };
                });

                dispatch(budgetsAddItem(newItem));

            } else {
                const newItems = items.map(it => {
                    if (it.id === item.id_titulo) {
                        return {
                            ...it,
                            items: [...it.items, newItem]
                        };
                    }
                    return it;
                });

                dispatch(budgetsLoadItems(newItems));

            }



        } catch (error) {
            console.log(error)
        }
    }
}

export const iniRemoveItem = (items, item, detail) => {
    return async (dispatch) => {
        try {

            const id = item.id;

            if (item.tipo === 'title') {
                const newItemsList = items.filter(item => item.id !== id);
                dispatch(budgetsLoadItems(newItemsList));

                const newTotales = await initialCalculoTotales(detail, newItemsList);
                dispatch(budgetsUpdateTotales(newTotales));

            } else {

                const newItemsList = items.map(title => {
                    if (title.id === item.id_titulo) {
                        const newItems = title.items.filter(it => it.id !== item.id);

                        const titleEnd = totalTitles(newItems)
                        return {
                            ...title,
                            ...titleEnd,
                            items: newItems
                        };
                    }
                    return title;
                });

                dispatch(budgetsLoadItems(newItemsList));

                const newTotales = await initialCalculoTotales(detail, newItemsList);
                dispatch(budgetsUpdateTotales(newTotales));

            }

        } catch (error) {
            console.log(error)
        }
    }
}

export const iniCreateBudget = () => {
    return async (dispatch) => {
        try {
            const newDetail = initialCreateBudgetNew();
            dispatch(budgetsLoadDetail(newDetail));
        } catch (error) {
            console.log(error);
            toast.error(error)
        }
    }
}

export const iniCreateBudgetDuplicate = (currentData) => {
    return async (dispatch) => {
        try {

            dispatch(startOpenProgress(true))

            const newDetail = await initialCreateBudgetDuplicate(currentData)
            dispatch(budgetsLoadDetail(newDetail))

            dispatch(startOpenProgress(false))

        } catch (error) {
            console.log(error)
            toast.error(error)

            dispatch(startOpenProgress(true))
        }
    }
}

export const iniSaveBudget = (detailBudget, navigate) => {
    return async (dispatch) => {
        try {

            dispatch(startOpenProgress(true))

            const resp = await fetchConToken('buyBudgets', detailBudget, 'POST');
            const body = await resp.json();
            if (body.ok) {

                if (body.ok) {
                    toast.success(body.msg);

                    const newIds = {
                        id: body.data.id,
                        numero: body.data.numero
                    }

                    dispatch(budgetsSetNewIds(newIds))
                    navigate(`/gastos/pptos/${body.data.id}`)

                } else {
                    toast.warning(body.msg);
                }
            }

            dispatch(startOpenProgress(false))

        } catch (error) {
            console.log(error)
            toast.error(error)

            dispatch(startOpenProgress(false))
        }
    }
}

export const iniUpdateBudget = (detailBudget) => {
    return async (dispatch) => {
        try {

            dispatch(startOpenProgress(true))

            const { id } = detailBudget
            const resp = await fetchConToken(`buyBudgets/${id}`, detailBudget, 'PUT')
            const body = await resp.json()

            if (body.ok) {
                if (id) {
                    dispatch(iniLoadBudgetsDetail(id))
                }
                toast.success(body.msg);
            } else {
                toast.warning(body.msg);
            }

            dispatch(startOpenProgress(false))

        } catch (error) {
            console.log(error)
            toast.error(error)

            dispatch(startOpenProgress(false))
        }
    }
}

export const iniSaveTemplate = (budgetId, newIsTemplate) => {
    return async (dispatch) => {
        try {

            dispatch(startOpenProgress(true))

            const dataForm = { is_template: newIsTemplate }
            const resp = await fetchConToken(`budgets/templates/update/${budgetId}`, dataForm, 'PUT')
            const body = await resp.json()

            if (body.ok) {
                dispatch(setIsTemplate(newIsTemplate))
                toast.info(body.msg)
            } else {
                toast.info(body.msg)
            }

            dispatch(startOpenProgress(false))

        } catch (error) {
            console.log(error)
            toast.error(error)

            dispatch(startOpenProgress(false))
        }
    }
}

export const iniChangeItems = (items, target, values, index) => {
    return async (dispatch) => {
        try {
            const newItems = items.map(item => {
                if (item.index === index) {
                    let newItem = item;
                    const floatValue = values.floatValue;
                    if (target === 'cant') newItem.cant = floatValue;
                    if (target === 'dias') newItem.dias = floatValue;
                    if (target === 'precio_unitario') newItem.precio_unitario = floatValue;
                    if (target === 'costo_unitario') newItem.costo_unitario = floatValue;
                    const subTotalPrecio = newItem.cant * newItem.dias * newItem.precio_unitario;
                    const subTotalCosto = newItem.cant * newItem.dias * newItem.costo_unitario;
                    const totalRentabilidad = subTotalPrecio - subTotalCosto;
                    const margenRentabilidad = (totalRentabilidad / subTotalPrecio) * 100;
                    newItem.precio_subtotal = subTotalPrecio;
                    newItem.costo_subtotal = subTotalCosto;
                    newItem.margen_monto = totalRentabilidad;
                    newItem.margen_porcentaje = margenRentabilidad;
                    return newItem;
                }
                return item;
            });
            dispatch(budgetsLoadItems(newItems));
        } catch (error) {
            console.log(error)
        }
    }
}

export const iniChangeItemsInside = (items, target, values, item) => {
    return async (dispatch, getState) => {
        try {

            const { listaTiposDocumentos } = getState().general
            const titleFound = items.filter(t => t.id === item.id_titulo);

            if (titleFound) {

                const newItems = items.map((title) => {
                    if (title.id === titleFound[0].id) {

                        const newItems_ = title.items.map(it => {
                            if (it.id === item.id) {
                                let newItem = it;
                                const floatValue = values.floatValue

                                if (target === 'cant') newItem.cant = floatValue
                                if (target === 'dias') newItem.dias = floatValue
                                if (target === 'costo_unitario') newItem.costo_unitario = floatValue

                                const subTotalCosto = newItem.cant * newItem.dias * newItem.costo_unitario
                                newItem.costo_subtotal = parseToNum(subTotalCosto, 2, true)

                                let impuesto_tipo_calculo = 'directo'
                                if (parseInt(newItem?.id_tipo_doc || 0) > 0) {
                                    const foundImpuesto = listaTiposDocumentos?.find(doc => parseInt(doc.id) === parseInt(newItem.id_tipo_doc))
                                    if (foundImpuesto) {
                                        const porcentaje = foundImpuesto.impuestos[0]?.porcentaje_impuesto || 18
                                        newItem.porcentaje_impuesto = parseFloat(porcentaje)
                                        impuesto_tipo_calculo = foundImpuesto.impuestos[0]?.tipo_calculo || 'directo'
                                    } else {
                                        newItem.id_tipo_doc = 1 // factura
                                        newItem.porcentaje_impuesto = 18
                                        impuesto_tipo_calculo = 'directo'
                                    }
                                } else {
                                    newItem.id_tipo_doc = 1 // factura
                                    newItem.porcentaje_impuesto = 18
                                    impuesto_tipo_calculo = 'directo'
                                }

                                console.log(newItem.id_tipo_doc, impuesto_tipo_calculo, newItem.porcentaje_impuesto)

                                const factorImpuesto = (newItem.porcentaje_impuesto ? (parseToNum(newItem.porcentaje_impuesto) / 100) : 0);
                                const totalImpuesto = parseToNum(newItem.costo_subtotal) * parseToNum(factorImpuesto)
                                newItem.total_impuesto = parseToNum(totalImpuesto, 2, true)

                                if (impuesto_tipo_calculo === 'retencion') {
                                    const totalAPagar = parseToNum(newItem.costo_subtotal) - parseToNum(newItem.total_impuesto)
                                    newItem.total_a_pagar = parseToNum(totalAPagar, 2, true)
                                } else {
                                    const totalAPagar = parseToNum(newItem.costo_subtotal) + parseToNum(newItem.total_impuesto)
                                    newItem.total_a_pagar = parseToNum(totalAPagar, 2, true)
                                }

                                return newItem

                            }

                            return it;

                        });

                        const titleEnd = totalTitles([...newItems_])
                        console.log({ titleEnd })

                        return {
                            ...title,
                            ...titleEnd,
                            items: newItems_
                        };

                    }
                    return title;
                })

                dispatch(budgetsLoadItems(newItems))
            }
        } catch (error) {
            console.log(error)
        }
    }
}

const totalTitles = (items) => {
    try {

        let totalTitle = {
            cant: 0,
            dias: 0,
            costo_unitario: 0,
            costo_subtotal: 0,
            total_impuesto: 0,
            total_a_pagar: 0
        }

        for (let x = 0; x < items.length; x++) {
            const currentCant = parseToNum(items[x].cant)
            const currentDias = parseToNum(items[x].dias)
            const currentCosto = parseToNum(items[x].costo_unitario)

            const subTotalCosto = currentCant * currentDias * currentCosto
            totalTitle.cant = parseToNum(totalTitle.cant) + currentCant
            totalTitle.dias = parseToNum(totalTitle.dias) + currentDias
            totalTitle.costo_unitario = parseToNum(totalTitle.costo_unitario) + currentCosto

            const totalCosto = parseToNum(totalTitle.costo_subtotal) + parseToNum(subTotalCosto)
            totalTitle.costo_subtotal = parseToNum(totalCosto, 2, true)

            const totalImpuesto = parseToNum(totalTitle.total_impuesto) + parseToNum(items[x].total_impuesto)
            totalTitle.total_impuesto = parseToNum(totalImpuesto, 2, true)

            const totalAPagar = parseToNum(totalTitle.total_a_pagar) + parseToNum(items[x].total_a_pagar)
            totalTitle.total_a_pagar = parseToNum(totalAPagar, 2, true)
        }

        return totalTitle

    } catch (error) {

        return {
            error: true,
            message: error
        }

    }
}

export const iniChangeItemsNameGastos = (items, values, item) => {
    return async (dispatch) => {
        try {
            const index = item.index;
            let newItems;

            if (item.tipo === 'title') {
                newItems = items.map(item => {
                    if (item.index === index) {
                        return {
                            ...item,
                            'nombre': values.nombre,
                            'id_categoria': values.id_categoria,
                            'id_servicio': values.id_servicio,
                            'id_titulo': values.id_titulo,
                        };
                    }
                    return item;
                });
            } else {

                const titleFound = items.filter(t => t.id === item.id_titulo);
                if (titleFound) {
                    newItems = items.map(title => {
                        if (title.id === titleFound[0].id) {

                            const newItems_ = title.items.map(it => {
                                if (it.id === item.id) {
                                    return {
                                        ...it,
                                        'nombre': values.nombre,
                                        'id_categoria': values.id_categoria,
                                        'id_servicio': values.id_servicio,
                                        'id_titulo': values.id_titulo,
                                    };
                                }
                                return it;
                            });

                            return {
                                ...title,
                                items: newItems_
                            };
                        }

                        return title;

                    });
                }

            }

            dispatch(budgetsLoadItems(newItems))

        } catch (error) {
            console.log(error)
        }
    }
}

export const iniChangeTotales = (detail, items) => {
    return async (dispatch, getState) => {
        try {
            const newTotales = await initialCalculoTotales(detail, items);
            dispatch(budgetsUpdateTotales(newTotales))

            const mangenPresupuestado = getState().ppto.detail?.margen_utilidad_p || 0
            const margenOptimo = getState().ppto.detail.validacion_rentabilidad_optima || 0

            const newStatus = await checkValidationStatus(mangenPresupuestado, margenOptimo)
            dispatch({
                type: types.budgetsUpdateValidationStatus,
                payload: newStatus
            })

        } catch (error) {
            console.log(error)
        }
    }
}

export const iniBudgetPreview = () => {
    return async (dispatch) => {

        try {
            const resp = await fetchConToken('budgets');
            const body = await resp.json();
            if (body.ok) {
                /* console.log(body.data); */
                dispatch(budgetsLoadList(body.data));
            }

        } catch (error) {
            console.log(error)
        }

    }
}

export const iniShareBudget = () => {
    return async (dispatch) => {

        try {
            const resp = await fetchConToken('budgets');
            const body = await resp.json();
            if (body.ok) {
                /* console.log(body.data); */
                dispatch(budgetsLoadList(body.data));
            }

        } catch (error) {
            console.log(error)
        }

    }
}

export const iniChangeAllPpto = (detailBudget) => {
    return async (dispatch) => {
        try {
            dispatch(budgetsLoadDetail(detailBudget));
        } catch (error) {
            console.log(error);
        }
    }
}

/* approve */
export const iniApprovePpto = (budgetId, type) => {
    return async (dispatch) => {
        try {

            dispatch(startOpenProgress(true))

            const resp = await fetchConToken(`budgets/approve/${budgetId}`, { type }, 'PUT');
            const body = await resp.json()

            if (body.ok) {
                dispatch(iniLoadBudgetsDetail(budgetId))
                toast.success(body.msg)
            } else {
                toast.warning(body.msg)
            }

            dispatch(startOpenProgress(false))

        } catch (error) {
            console.log(error)
            toast.error(error)

            dispatch(startOpenProgress(false))
        }
    }
}
/* approve */

/* -- validations */
export const iniValidateProfit = (budgetId, comments) => {
    return async (dispatch, getState) => {
        try {

            dispatch(startOpenProgress(true))

            const { uid } = getState().auth

            const dataForm = {
                id_validador: uid,
                comentario: comments
            }

            const resp = await fetchConToken(`budgets/validate/${budgetId}`, dataForm, 'PUT');
            const body = await resp.json()

            if (body.ok) {
                dispatch(iniLoadBudgetsDetail(budgetId))
                toast.success(body.msg)
            } else {
                toast.warning(body.msg)
            }

            dispatch(startOpenProgress(false))

        } catch (error) {
            console.log(error)
            toast.error(error)

            dispatch(startOpenProgress(false))
        }
    }
}

export const iniRequestValidation = (budgetId) => {
    return async (dispatch) => {
        try {

            dispatch(startOpenProgress(true))

            const resp = await fetchConToken(`budgets/validate/request/${budgetId}`, {}, 'PUT');
            const body = await resp.json()

            if (body.ok) {
                dispatch(iniLoadBudgetsDetail(budgetId))
                toast.success(body.msg)
            } else {
                toast.warning(body.msg)
            }

            dispatch(startOpenProgress(false))

        } catch (error) {
            console.log(error)
            toast.error(error)

            dispatch(startOpenProgress(false))
        }
    }
}

export const iniRestartValidation = (budgetId, comments) => {
    return async (dispatch) => {
        try {

            dispatch(startOpenProgress(true))

            const dataForm = {
                comentario: comments
            }

            const resp = await fetchConToken(`budgets/validate/restart/${budgetId}`, dataForm, 'PUT');
            const body = await resp.json()

            if (body.ok) {
                dispatch(iniLoadBudgetsDetail(budgetId))
                toast.success(body.msg)
            } else {
                toast.warning(body.msg)
            }

            dispatch(startOpenProgress(false))

        } catch (error) {
            console.log(error)
            toast.error(error)

            dispatch(startOpenProgress(false))
        }
    }
}

export const iniRejectValidation = (budgetId, comments) => {
    return async (dispatch) => {
        try {

            dispatch(startOpenProgress(true))

            const dataForm = {
                comentario: comments
            }

            const resp = await fetchConToken(`budgets/validate/reject/${budgetId}`, dataForm, 'PUT');
            const body = await resp.json()

            if (body.ok) {
                dispatch(iniLoadBudgetsDetail(budgetId))
                toast.error(body.msg)
            } else {
                toast.warning(body.msg)
            }

            dispatch(startOpenProgress(false))

        } catch (error) {
            console.log(error)
            toast.error(error)

            dispatch(startOpenProgress(false))
        }
    }
}
/* -- validations */

/* initial services */
export const initAddInitialServices = (orderedItems) => {
    return async (dispatch) => {
        try {
            dispatch(budgetsLoadItems(orderedItems))
        } catch (error) {
            console.log(error)
        }
    }
}
/* initial services */

export const iniChangeItemsChecked = (items, checked, item) => {
    return async (dispatch) => {
        try {
            const titleFound = items.filter(t => t.id === item.id_titulo);
            if (titleFound) {
                const newItems = items.map(title => {
                    if (title.id === titleFound[0].id) {
                        const newItems_ = title.items.map(it => {
                            if (it.id === item.id) {
                                let newItem = it;
                                newItem.selected = checked;
                                return newItem;
                            }
                            return it;
                        });
                        return {
                            ...title,
                            items: newItems_
                        };
                    }
                    return title;
                })

                dispatch(budgetsLoadItems(newItems))
            }

        } catch (error) {
            console.log(error)
        }
    }
}

export const iniChangeItemsTipoDoc = (items, newIdDoc, item) => {
    return async (dispatch, getState) => {
        try {

            const { listaTiposDocumentos } = getState().general
            const titleFound = items.filter(t => t.id === item.id_titulo);
            if (titleFound) {
                const newItems = items.map(title => {
                    if (title.id === titleFound[0].id) {

                        const newItems_ = title.items.map(it => {
                            if (it.id === item.id) {
                                let newItem = it
                                newItem.id_tipo_doc = newIdDoc

                                const foundImpuesto = listaTiposDocumentos?.find(doc => parseInt(doc.id) === parseInt(newIdDoc))
                                const porcentaje = foundImpuesto.impuestos[0]?.porcentaje_impuesto || 18
                                newItem.porcentaje_impuesto = parseFloat(porcentaje)
                                const impuesto_tipo_calculo = foundImpuesto.impuestos[0]?.tipo_calculo || 'directo'

                                const factorImpuesto = (newItem.porcentaje_impuesto ? (parseToNum(newItem.porcentaje_impuesto) / 100) : 0);
                                const totalImpuesto = parseToNum(newItem.costo_subtotal) * parseToNum(factorImpuesto)
                                newItem.total_impuesto = parseToNum(totalImpuesto, 2, true)

                                if (impuesto_tipo_calculo === 'retencion') {
                                    const totalAPagar = parseToNum(newItem.costo_subtotal) - parseToNum(newItem.total_impuesto)
                                    newItem.total_a_pagar = parseToNum(totalAPagar, 2, true)
                                } else {
                                    const totalAPagar = parseToNum(newItem.costo_subtotal) + parseToNum(newItem.total_impuesto)
                                    newItem.total_a_pagar = parseToNum(totalAPagar, 2, true)
                                }

                                return newItem

                            }

                            return it

                        });

                        return {
                            ...title,
                            items: newItems_
                        };

                    }

                    return title
                })

                dispatch(budgetsLoadItems(newItems))
            }

        } catch (error) {
            console.log(error)
        }
    }
}

const setIsTemplate = (isTemplate) => ({
    type: types.budgetsSetIsTemplate,
    payload: isTemplate
})

export const budgetsLoadDetail = (budgetsDetail) => ({
    type: types.budgetsLoadDetail,
    payload: budgetsDetail
})

const budgetsLoadList = (pptos) => ({
    type: types.pptoCargarLista,
    payload: pptos
})

const budgetsLoadItems = (itemList) => ({
    type: types.budgetsLoadItems,
    payload: itemList
})

const budgetsAddItem = (newItem) => ({
    type: types.budgetsAddItem,
    payload: newItem
})

const budgetsUpdateTotales = (totales) => ({
    type: types.budgetsUpdateTotales,
    payload: totales
})

const budgetsSetNewIds = (newIds) => ({
    type: types.budgetsSetNewIds,
    payload: newIds
})

export const budgetsUpdateDatosInicialesNotSave = (dataUpdate) => ({
    type: types.budgetsUpdateDatosInicialesNotSave,
    payload: dataUpdate
})

export const budgetsUpdateCondicionesNotSave = (dataUpdate) => ({
    type: types.budgetsUpdateCondicionesNotSave,
    payload: dataUpdate
})

export const budgetsUpdateMontosFinalNotSave = (dataUpdate) => ({
    type: types.budgetsUpdateMontosFinalNotSave,
    payload: dataUpdate
})

export const orderDetailPpts = (pptoOrder) => {
    return async (dispatch) => {
        try {
            dispatch(budgetsLoadItems(pptoOrder));

        } catch (error) {
            console.log(error)
        }
    }
}
